/* Logo with WebP-first <picture> source + PNG fallback.
   eager + high-priority because the logo is in the first viewport of every page. */
export default function Logo({ className = "h-8", testid = "brand-logo" }) {
  return (
    <picture>
      <source srcSet="/logo.webp" type="image/webp" />
      <img
        src="/logo.png"
        alt="Allure Image"
        width={520}
        height={199}
        loading="eager"
        fetchPriority="high"
        decoding="async"
        data-testid={testid}
        className={`${className} w-auto object-contain object-left select-none max-w-[180px] sm:max-w-none`}
        draggable={false}
      />
    </picture>
  );
}
